import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-consent-dialog",
  templateUrl: "./consent-dialog.component.html",
  styleUrls: ["./consent-dialog.component.scss"],
})
export class ConsentDialogComponent {
  constructor(public dialogRef: MatDialogRef<ConsentDialogComponent>) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
